'use client';

import { FC } from 'react';
import { Container, Head, Wrapper } from '@/features/pages/home';
import { Typography } from '@mui/material';
import { COLORS } from '@/constants';

import individualBgBuilding from '@/assets/webp/bg-building.webp';
import { BgFigure, GridList } from './styles';
import { HousingCard } from '@/components';
import { useTranslations } from 'next-intl';
import { IHousingObjectResponse } from '@/types';

type IndividualProjectProps = {
  data: IHousingObjectResponse[] | null;
};

export const IndividualProject: FC<IndividualProjectProps> = ({ data }) => {
  const t = useTranslations();

  return (
    <Wrapper>
      <Container>
        <Head>
          <Typography
            fontSize={{ xs: 26, sm: 26, md: 34 }}
            lineHeight={1}
            fontWeight={700}
            color={COLORS.blue}
          >
            {t('individualProperty.title')}
          </Typography>
        </Head>
        <GridList>
          {data?.map((project) => (
            <HousingCard data={project} key={project.id} isProject />
          ))}
        </GridList>
      </Container>
      <BgFigure>
        <img src={individualBgBuilding.src} alt="" />
      </BgFigure>
    </Wrapper>
  );
};
